export const polygonOptions = {
    fillOpacity: 0.2,
    fillColor: '#303091',
    strokeColor: '#303091',
    strokeWeight: 2,
    draggable: true,
    editable: true,
    clickable: true,
    geodesic: false,
    zIndex: 1,
}

// Terra Draw styling for the in-progress polygon, matched to polygonOptions
// so the shape looks the same while it is drawn and once it is committed.
export const drawPolygonStyles = {
    fillColor: '#303091',
    fillOpacity: 0.2,
    outlineColor: '#303091',
    outlineWidth: 2,
    closingPointColor: '#FFFFFF',
    closingPointOutlineColor: '#303091',
} as const
